const INITIAL_STATE = {};

export const ADMIN_SAVE_PHASE_SET = 'ADMIN_SAVE_PHASE_SET';

export default function adminSavePhase(state = INITIAL_STATE, action) {
  if (action.type === ADMIN_SAVE_PHASE_SET) {
    const { formName, phase } = action.payload;
    if (phase === null) {
      const newState = { ...state };
      delete newState[formName];
      return newState;
    }
    return { ...state, [formName]: phase };
  }
  return state;
}

export const selectAdminSavePhase = (state, formName) =>
  state.adminSavePhase?.[formName] ?? null;
